import React, { useState } from 'react';
import ImgEqual from '../../../../assets/equal.png';
import ImgEqualHighlight from '../../../../assets/equal-highlight.png';
import ImgPoint from '../../../../assets/animation_point.gif';
import { useStore } from '../../store';
import { useParams } from 'react-router-dom';

const AnswerCover = (props: {
  children: React.ReactNode;
  onChange?: () => void;
  onCoverChange?: any;
}) => {
  const param = useParams();
  const { children, onChange, onCoverChange } = props;
  const [isCovered, setIsCovered] = useState(true);
  const { courses } = useStore();
  const p_course = param.course;
  if (!p_course) {
    return <div>Loading</div>;
  }
  const course = courses[p_course];
  const { components: settings } = course;
  const handleClick = () => {
    setIsCovered(false);
    onCoverChange && onCoverChange(true);
    if (onChange) {
      onChange();
    }
  };

  return (
    <>
      <img src={isCovered ? ImgEqual : ImgEqualHighlight} alt="equal" />
      {isCovered ? (
        <div className="highlight" onClick={handleClick}>
          <div className="panel">
            <div
              className="l2"
              dangerouslySetInnerHTML={{
                __html: settings?.answerCoverLabel || '',
              }}
            />
            <img className="point" src={ImgPoint} alt="point" />
          </div>
        </div>
      ) : (
        children
      )}
    </>
  );
};

export default AnswerCover;
